<template>
  <div class="nuttrema-layout-default-slide" :class="[`theme-${theme}`, { 'is-move': move, 'is-expanded': isExpanded }]">

    <div class="nuttrema-layout-default-slide__bg"></div>

    <slot name="overflow"></slot>

    <div class="nuttrema-layout-default-slide__sidebar" :style="sidebarStyle">

        <div
           class="nuttrema-layout-default-slide__sidebar__collapsed"
          :style="sidebarCollapsedStyle"
          :class="{ 'is-level-one': hasSlotExpandedMenuLevelOne, 'showing-level-one': hasSlotExpandedMenuLevelOne && !isExpanded }">

          <slot name="sidebar-collapsed">

            <div class="sidebar-collapsed__top">

              <div class="sidebar-collapsed__top__brand">
                <slot name="collapsed-menu-top-brand"></slot>
              </div>

              <div class="sidebar-collapsed__top__menu">
                <router-view name="collapsedMenuTop"></router-view>
                <slot name="collapsed-menu-top"></slot>
              </div>

            </div>
            <!-- end ~ sidebar-collapsed__top -->

            <div class="sidebar-collapsed__center">
              <div
                 class="sidebar-collapsed__center__menu"
                :class="{ 'is-level-one': hasSlotExpandedMenuLevelOne }">
                <slot name="collapsed-menu-level-zero"></slot>
                <slot name="collapsed-menu-level-one"></slot>
              </div>
            </div>
            <!-- end ~ sidebar-collapsed__center -->

            <!-- {{ isExpanded ? $t('label.collapse') : $t('label.expand') }} -->
            <div class="sidebar-collapsed__bottom">
              <router-view name="sidebarCollapsedBottom" ></router-view>
              <slot name="sidebar-collapsed-bottom"></slot>
              <el-tooltip class="item" effect="dark" :content="isExpanded ? $t('label.collapse_sidebar') : $t('label.expand_sidebar')" placement="top" :open-delay="500" >
                <button
                   class="sidebar-collapsed__bottom__toggle-button"
                  :class="{ 'is-expanded': isExpanded }"
                  @click="toggleMode"
                  @mouseover="$emit('hover')">
                  <i class="far" :class="isExpanded ? 'fa-chevron-double-left' : 'fa-chevron-double-right'"></i>
                </button>
              </el-tooltip>
            </div>
            <!-- end ~ sidebar-collapsed-bottom -->

          </slot>
          <!-- end ~ slot sidebar-collapsed -->

        </div>
        <!-- end ~ nuttrema-layout-default-slide__sidebar__collapsed -->

        <div
           class="nuttrema-layout-default-slide__sidebar__expanded"
          :class="{ 'is-level-one': hasSlotExpandedMenuLevelOne }"
          :style="sidebarExpandedStyle">
            <slot name="expanded-menu-level-zero"></slot>
            <slot name="expanded-menu-level-one"></slot>
        </div>
    </div>

    <div
       v-if="canToggle"
       class="nuttrema-layout-default-slide__resize"
      :style="resizeStyle">
      <div class="nuttrema-layout-default-slide__resize__line"
        @mousedown="startMove">
        <button
           class="nuttrema-layout-default-slide__resize__toggler"
          :class="{ 'is-expanded': isExpanded }"
          @click="toggleMode"
          @mouseover="$emit('hover')">
        </button>
      </div>
    </div>

    <div class="nuttrema-layout-default-slide__content">
      <slot name="content">
        <router-view></router-view>
      </slot>
    </div>

  </div>
</template>

<script>
import { ls } from 'services';
import { isNumber } from 'lodash';

import * as KEYS from 'constants/keys';
import * as EVENT from 'constants/event';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';
import ZeroLevelCreate from 'components/ui/west-slide-component/zero-level-create';

export default {
  name: 'nuttrema-layout-default-slide',
  props: {
    collapsed: {
      type: Number,
      required: false,
      default: 64,
    },
    expanded: {
      type: Number,
      required: false,
      default: 304,
    },
    minExpanded: {
      type: Number,
      required: false,
      default: 212,
    },
    maxExpanded: {
      type: Number,
      required: false,
      default: 404,
    },
    offsetRight: {
      type: Number,
      required: false,
      default: 50,
    },
    offsetLeft: {
      type: Number,
      required: false,
      default: 5,
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    layoutSlideModeKey: {
      type: String,
      required: false,
      default: KEYS.LAYOUT_DEFAULT_SLIDE_MODE,
    },
    canToggle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    ZeroLevelCreate,
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      brandLink: 'professional-home',
      move: false,
      layoutOffset: 0,
      isExpanded: true,
      westSlideComponent: null,
      mode: {
        expanded: 'mode.expanded',
        collapsed: 'mode.collapsed',
      },
      sidebar: {
        collapsedWidth: this.collapsed,
        expandedWidth: this.expanded,
        totalWidth: this.collapsed + this.expanded,
        minTotalWidth: this.collapsed + this.minExpanded,
        maxTotalWidth: this.collapsed + this.maxExpanded,
        maxMoveRight: this.collapsed + this.maxExpanded + this.offsetRight,
        maxMoveLeft: this.collapsed - this.offsetLeft,
        expandedLeft: 0,
        expandedOpacity: 1,
      },
      resize: {
        x: this.collapsed + this.expanded,
      },
    };
  },
  computed: {
    sidebarStyle() {
      return `flex: 0 1 ${this.sidebar.totalWidth}px; width: ${this.sidebar.totalWidth}px; min-width: ${this.sidebar.totalWidth}px;`;
    },
    sidebarCollapsedStyle() {
      return `flex: 0 1 ${this.sidebar.collapsedWidth}px; min-width: ${this.sidebar.collapsedWidth}px;`;
    },
    sidebarExpandedStyle() {
      return `transform: translate3d(${this.sidebar.expandedLeft}px,0,0); min-width: ${this.sidebar.minExpanded}px; flex: 0 0 ${this.sidebar.expandedWidth}px; width: ${this.sidebar.expandedWidth}px;`;
    },
    resizeStyle() {
      return `left: ${this.resize.x}px;`;
    },
    hasSlotExpandedMenuLevelZero() {
      return !!this.$slots['expanded-menu-level-zero'];
    },
    hasSlotExpandedMenuLevelOne() {
      return !!this.$slots['expanded-menu-level-one'];
    },
  },
  methods: {
    startMove() {
      this.move = true;
    },
    endMove() {
      // console.log('endMove');
      if (this.move) {
        this.move = false;
        if (this.resize.x > this.sidebar.collapsedWidth && this.resize.x < this.sidebar.minTotalWidth) {
          this.sidebar.expandedLeft = 0;
          this.resize.x = this.sidebar.minTotalWidth;
          this.sidebar.expandedWidth = this.minExpanded;
          this.sidebar.totalWidth = this.sidebar.minTotalWidth;
        }

        if (this.resize.x >= this.sidebar.maxTotalWidth) {
          this.resize.x = this.sidebar.maxTotalWidth;
          this.sidebar.totalWidth = this.sidebar.maxTotalWidth;
          this.sidebar.expandedWidth = this.maxExpanded;
        }

        ls.set(KEYS.LAYOUT_DEFAULT_SLIDE_WIDTH, this.sidebar.expandedWidth);
        window.Eventus.$emit(EVENT.LAYOUT_DEFAULT_SLIDE_MOVE);
      }
    },
    moveSidebar(event) {
      if (this.move) {
        if (event.pageX <= this.sidebar.collapsedWidth) {
          this.makeCollapse();
        } else if (event.pageX > this.sidebar.collapsedWidth && event.pageX <= this.sidebar.maxMoveRight) {
          this.isExpanded = true;
          const expandedCurrent = event.pageX - this.collapsed;
          this.sidebar.expandedWidth = (expandedCurrent >= this.minExpanded) ? expandedCurrent : this.minExpanded;
          const totalCurrent = this.sidebar.expandedWidth + this.collapsed;
          const difference = (event.pageX <= totalCurrent) ? event.pageX - totalCurrent : 0;
          this.resize.x = event.pageX;
          this.sidebar.totalWidth = event.pageX;
          this.sidebar.expandedLeft = difference;
          // console.log('moveSidebar', event.pageX, expandedCurrent, this.sidebar.expandedWidth, totalCurrent, difference, this.sidebar.totalWidth, this.sidebar.expandedLeft);
        }
      }
    },
    makeExpanded() {
      this.isExpanded = true;
      this.sidebar.totalWidth = this.sidebar.collapsedWidth + this.sidebar.expandedWidth;
      this.resize.x = this.sidebar.totalWidth;
      ls.set(this.layoutSlideModeKey, this.mode.expanded);
      ls.set(KEYS.LAYOUT_DEFAULT_SLIDE_WIDTH, this.sidebar.expandedWidth);
      setTimeout(() => {
        window.Eventus.$emit(EVENT.LAYOUT_DEFAULT_SLIDE_MOVE);
      }, 300);
    },
    makeCollapse() {
      // console.log('in makeCollapse');
      this.isExpanded = false;
      this.resize.x = this.sidebar.collapsedWidth;
      this.sidebar.totalWidth = this.sidebar.collapsedWidth;
      ls.set(this.layoutSlideModeKey, this.mode.collapsed);
      ls.set(KEYS.LAYOUT_DEFAULT_SLIDE_WIDTH, this.sidebar.expandedWidth);
      setTimeout(() => {
        window.Eventus.$emit(EVENT.LAYOUT_DEFAULT_SLIDE_MOVE);
      }, 300);
    },
    toggleMode(event) {
      event.target.blur();
      if (this.isExpanded) this.makeCollapse();
      else this.makeExpanded();
    },
    setExpandedWidth(width) {
      width = isNumber(Number(width)) ? Number(width) : this.expanded;
      this.sidebar.expandedWidth = width;
      this.sidebar.totalWidth = this.collapsed + width;
      this.resize.x = this.collapsed + width;
    },
  },
  created() {
    const width = ls.get(KEYS.LAYOUT_DEFAULT_SLIDE_WIDTH);
    if (width) this.setExpandedWidth(width);

    if (!this.canToggle) {
      this.makeExpanded();
    } else {
      const mode = ls.get(this.layoutSlideModeKey) || this.mode.expanded;
      if (mode === this.mode.collapsed) this.makeCollapse();
      else this.makeExpanded();
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.moveSidebar);
    document.addEventListener('mouseup', this.endMove);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.moveSidebar);
    document.removeEventListener('mouseup', this.endMove);
    window.Eventus.$off(EVENT.LAYOUT_DEFAULT_SLIDE_MOVE);
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/mixins/gradients";

  $toggle-button-color: darken($turquoise, 10%);
  $toggle-button-color-topography: #00BCD4;

  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
  }

  .component-slide-enter-active, .component-slide-leave-active {
    transform: translate3d(0, 0, 0);
  }
  .component-slide-enter, .component-slide-leave-to {
    transform: translate3d(-100%, 0, 0);
  }

  .nuttrema-layout-default-slide {
    display: flex;
    flex-grow: 1;
    align-self: stretch;
    position: relative;

    .nuttrema-layout-default-slide__sidebar, .nuttrema-layout-default-slide__resize {
      transition-property: all;
      transition-duration: 100ms;
    }

    .nuttrema-layout-default-slide__sidebar {
      z-index: 19;
      display: flex;
      align-self: stretch;

      .nuttrema-layout-default-slide__sidebar__collapsed {
        z-index: 20;
        display: flex;
        overflow: hidden;
        align-self: stretch;
        flex-direction: column;
        justify-content: space-between;
        background-color: $turquoise;
        height: 100vh;

        &.is-level-one {
          background-color: darken($index-list-bg, 10%);
        }

        .sidebar-collapsed__top, .sidebar-collapsed__center, .sidebar-collapsed__bottom {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .sidebar-collapsed__top {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          flex-shrink: 0;
          .sidebar-collapsed__top__brand {
            display: flex;
            margin: 0.5em 0;
            a.brand-image {
              display: flex;
              justify-content: center;
              align-items: center;
              // height: 52px;
              img {
                width: 80%;
              }
            }
          }
          .sidebar-collapsed__top__menu {
            display: flex;
            flex-direction: column;
          }
        }

        .sidebar-collapsed__center {
          display: flex;
          flex-grow: 1;
          justify-content: center;
          align-items: center;
          opacity: 1;
          overflow: hidden;
          overflow-y: auto;

          .sidebar-collapsed__center__menu {
            display: flex;
            padding: 1em 0;
            position: relative;

            .collapsed-menu-level-zero,
            .collapsed-menu-level-one {
              transition-property: all;
              transition-duration: 300ms;
            }

            .collapsed-menu-level-zero {
              opacity: 1;
              display: block;
              visibility: visible;
            }

            .collapsed-menu-level-one {
              opacity: 0;
              display: none;
              visibility: hidden;
            }

            &.is-level-one {
              .collapsed-menu-level-zero {
                opacity: 0;
                display: none;
                visibility: hidden;
              }
              .collapsed-menu-level-one {
                opacity: 1;
                display: block;
                visibility: visible;
              }
            }
          }
        }

        .sidebar-collapsed__bottom {
          flex-shrink: 0;
          margin: 0.5em 0;
          flex-direction: column;

          .sidebar-collapsed__bottom__toggle-button {
            width: 3em;
            padding: 0;
            color: #fff;
            border: none;
            max-width: 3em;
            margin: 0.25em 0 0;
            text-align: center;
            border-radius: 0.25em;
            background-color: $toggle-button-color;

            &.is-expanded {}

            &:hover, &:focus, &:active {
              cursor: pointer;
              background-color: darken($toggle-button-color, 5%);
            }

            i {
              line-height: 1.5;
            }
          }
        }

      }

      .nuttrema-layout-default-slide__sidebar__expanded {
        z-index: 10;
        flex-grow: 1;
        display: none;
        align-self: stretch;
        border-right: 2px solid #dbe2ef;
        @include gradient-vertical($sidebar-gradient-color-top, $sidebar-gradient-color-bottom, 30%);

        &.is-level-one {
          @include gradient-vertical($sidebar-gradient-color-top, darken($index-list-bg, 10%), 30%);
        }

        .sidebar-expanded__menu {
          padding: 0 0.5em;
          width: 100%;
          .expanded-menu-level-zero { display: block; }
          .expanded-menu-level-one { display: none; }
          &.is-level-one {
            .expanded-menu-level-zero { display: none; }
            .expanded-menu-level-one { display: block; }
          }
        }
      }
    }

    .nuttrema-layout-default-slide__resize {
      width: 1em;
      height: 100vh;
      position: absolute;
      display: inline-block;
      z-index: 30;

      &:hover {
        .nuttrema-layout-default-slide__resize__toggler {
          visibility: visible;
        }
        .nuttrema-layout-default-slide__resize__line {
          &:before {
            opacity: 1;
            background-color: $toggle-button-color;
          }
          .nuttrema-layout-default-slide__resize__toggler {
            &:before, &:after {
              background-color: darken($toggle-button-color, 5%);
            }
          }
        }
      }

      .nuttrema-layout-default-slide__resize__line {
        z-index: 14;
        left: -7px;
        width: 12px;
        height: 100vh;
        position: absolute;
        &:before {
          content: '';
          width: 2px;
          height: 100%;
          position: absolute;
          left: 5px;
          // opacity: 0;
          background: darken($turquoise, 5%);
        }
        &:hover {
          cursor: ew-resize;
          &:before {
            opacity: 1;
          }
        }
      }

      .nuttrema-layout-default-slide__resize__toggler {
        position: relative;
        top: -webkit-calc(50% - 18px);
        top: -moz-calc(50% - 18px);
        top: calc(50% - 18px);
        height: 36px;
        background: none;
        border: none;
        color: transparent;
        width: 24px;
        left: 1px;
        cursor: pointer;
        // visibility: hidden;
        &:before, &:after {
          content: '';
          // background-color: $turquoise;
          background-color: #DBE2EF;
          width: 2px;
          border-radius: 16px;
          height: 8px;
          position: absolute;
          // left: 13px; old
          left: 10px;
          transition: -ms-transform 200ms ease-in-out, -webkit-transform 200ms ease-in-out, transform 200ms ease-in-out, opacity 300ms ease-in-out;
          -webkit-transition: -webkit-transform 200ms ease-in-out, transform 200ms ease-in-out, opacity 300ms ease-in-out;
          transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          -webkit-transform: rotate(0deg);
        }
        &:before {
          top: 10px;
          transform-origin: 1px 7px;
          -ms-transform-origin: 1px 7px;
          -webkit-transform-origin: 1px 7px;
        }
        &:after {
          top: 16px;
          transform-origin: 1px 1px;
          -ms-transform-origin: 1px 1px;
          -webkit-transform-origin: 1px 1px;
        }

        &:hover, &:focus {
          outline: none;
          // left: 1px;
          left: 4px;
          &:before, &:after {
            background-color: darken($turquoise, 5%);
          }
        }

        &:hover:before, &:focus:before {
          transform: rotate(-40deg);
          -ms-transform: rotate(-40deg);
          -webkit-transform: rotate(-40deg);
        }

        &:hover:after, &:focus:after {
          transform: rotate(40deg);
          -ms-transform: rotate(40deg);
          -webkit-transform: rotate(40deg);
        }

        &.is-expanded {
          &:hover, &:focus {
            left: 1px;
          }
          &:hover:before, &:focus:before {
            transform: rotate(40deg);
            -ms-transform: rotate(40deg);
            -webkit-transform: rotate(40deg);
          }
          &:hover:after, &:focus:after {
            transform: rotate(-40deg);
            -ms-transform: rotate(-40deg);
            -webkit-transform: rotate(-40deg);
          }
        }
      }
    }

    .nuttrema-layout-default-slide__content {
      display: flex;
      flex-grow: 1;
      align-self: stretch;
      justify-content: center;
      background-color: $index-list-bg;

      height: 100vh;
      // firefox-fix @supports (-moz-appearance:none) {}
    }

    &.is-index-mode {
      .nuttrema-layout-default-slide__resize:hover {
        width: 2em;
        @include gradient-horizontal(rgba(#fff, 0.5), rgba(#fff, 0), 30%);
      }
    }

    &.is-expanded {
      .nuttrema-layout-default-slide__sidebar {
        .nuttrema-layout-default-slide__sidebar__expanded {
          display: flex;
        }
        .nuttrema-layout-default-slide__sidebar__collapsed {
          &.is-level-one {
            background-color: $turquoise;

            .sidebar-collapsed__top__menu {
              /deep/ .nuttrema-menu-list-item.collapsed-menu-level-one {
                opacity: 0;
                display: none;
                visibility: hidden;
              }
            }
          }

          .sidebar-collapsed__center__menu {
            .collapsed-menu-level-zero { display: none; }
            // .collapsed-menu-level-one { display: block; }
            &.is-level-one {
              .collapsed-menu-level-zero {
                opacity: 1;
                display: block;
                visibility: visible;
              }
              .collapsed-menu-level-one {
                opacity: 0;
                display: none;
                visibility: hidden;
              }
            }
          }
        }
      }
    }

    &.is-scrollable-content {
      .nuttrema-layout-default-slide__content {
        overflow-y: auto;
      }
    }

    &.theme-login {
      .nuttrema-layout-default-slide__sidebar__expanded {
        border-right: none;
        @include gradient-vertical($sidebar-gradient-color-top, #fff, 30%);
      }
    }

    &.is-move {
      .nuttrema-layout-default-slide__sidebar, .nuttrema-layout-default-slide__resize {
        transition-duration: inherit;
      }
      .nuttrema-layout-default-slide__resize__line:before {
        opacity: 1;
      }
    }


    &.theme-topography, .nuttrema-theme-professional-topography & {
      background-color: #fff;

      .nuttrema-layout-default-slide__bg {
        z-index: 0;
        opacity: 0.35;
        position: absolute;
        background-size: 125% auto;
        background-repeat: no-repeat;
        background-image: url('~assets/images/landing-background-shapes-4.svg');
        top: 0; left: 0; right: 0; bottom: 0;
      }

      &.is-light {
        &:after {
          opacity: 0.25;
        }
      }

      &.is-normal {
        &:after {
          opacity: 0.35;
        }
      }

      &.is-lighter {
        &:after {
          opacity: 0.15;
        }
      }

      .nuttrema-layout-default-slide__content {
        background-color: transparent;
      }

      .nuttrema-layout-default-slide__sidebar__collapsed {
        background-color: rgba(#607d8b, 0.25);
        &.is-level-one {
          background-color: rgba(#607d8b, 0.25);
        }
      }

      .nuttrema-layout-default-slide__resize__line {
        &:before {
          background: rgba($toggle-button-color-topography, 0.25);
        }
      }

      .nuttrema-layout-default-slide__resize__toggler {
        // left: -3px;
        &:before, &:after {
          // background-color: darken(#dbe2f0, 10%);
          background: $toggle-button-color;
        }
        &:hover, &:focus {
          &:before, &:after {
            background-color: darken(#dbe2f0, 15%);
          }
        }
      }

      &.is-move {
        .nuttrema-layout-default-slide__resize__line:before {
          opacity: 1;
        }
      }


      .nuttrema-layout-default-slide__sidebar__expanded {
        border-right: none;
        background: transparent;
        box-shadow: inset -2px 0 2px -1px rgba(0,0,0,0.15);
        @include gradient-vertical-no-bg(transparent, rgba(#fff, 0.75), 50%);

        &.is-level-one {
          background: transparent;
          @include gradient-vertical-no-bg(transparent, rgba(#fff, 0.85), 30%);
        }
      }


      .nuttrema-layout-default-slide__resize {
        .nuttrema-layout-default-slide__resize__toggler {
          &:before, &:after {
            background-color: $toggle-button-color-topography !important;
          }
        }

        &:hover {
          .nuttrema-layout-default-slide__resize__line {
            &:before {
              background-color: $toggle-button-color-topography !important;
            }
            .nuttrema-layout-default-slide__resize__toggler {
              &:before, &:after {
                background-color: darken($toggle-button-color-topography, 5%) !important;
              }
            }
          }
        }
      }


      .sidebar-collapsed__bottom__toggle-button {
        background-color: $toggle-button-color-topography !important;
        &:hover, &:focus, &:active {
          background-color: darken($toggle-button-color-topography, 5%) !important;
        }
      }

      &.is-expanded {
        .nuttrema-layout-default-slide__sidebar__collapsed {
          background-color: transparent;
          &.is-level-one {
            background-color: transparent;
            // background-color: rgba(#607d8b, 0.25);
          }
        }
      }

    }
    // end - nuttrema-theme-professional-topography

    &.theme-turquoise, .nuttrema-theme-professional-turquoise & {
      .nuttrema-layout-default-slide__bg {
        z-index: 0;
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        @include gradient-horizontal($turquoise, darken($turquoise, 7%));
      }

      .nuttrema-layout-default-slide__content {
        background-color: transparent;
      }
      .nuttrema-layout-default-slide__sidebar__expanded {
        border-right: none;
        box-shadow: inset -2px 0 2px -1px rgba(0,0,0,0.15);
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-default-slide.vue